import { PlayerPosition } from '@core/enums/player.enums'
import { MetricDetailType } from '@features/metric-detail/models/metric-detail.models'

export const METRIC_DETAIL_FEATURE_TOKEN = 'metricDetail'

export const METRIC_DETAIL_POSITION_AVERAGE_BY_PLAYER_POSITION = {
  [PlayerPosition.Goalkeeper]: 'MTR_METRIC_DETAIL_GOALKEEPER_AVERAGE',
  [PlayerPosition.Defender]: 'MTR_METRIC_DETAIL_DEFENDER_AVERAGE',
  [PlayerPosition.Midfielder]: 'MTR_METRIC_DETAIL_MIDFIELDER_AVERAGE',
  [PlayerPosition.Forward]: 'MTR_METRIC_DETAIL_FORWARD_AVERAGE'
}

export const METRIC_DETAIL_AGGREGATION_TEXT_BY_TYPE: { [key in MetricDetailType]?: string } = {
  averageValue: 'MTR_COMMON_AVERAGE',
  average: 'MTR_COMMON_AVERAGE',
  accumulated: 'MTR_COMMON_ACCUMULATED',
  maximum: 'MTR_COMMON_MAXIMUM',
  maximum1T: 'MTR_COMMON_MAXIMUM_1T',
  maximum2T: 'MTR_COMMON_MAXIMUM_2T',
  metric: 'MTR_COMMON_MATCH_VALUE',
  metricValue: 'MTR_COMMON_MATCH_VALUE',
  averageCompetitionValue: 'MTR_COMMON_AVERAGE_COMPETITION'
}

export const METRIC_DETAIL_SORT_WEIGHT: { [key in MetricDetailType]?: number } = {
  metric: 0,
  metricValue: 0,
  averageValue: 1,
  average: 1,
  averagePositionValue: 1,
  averageCompetitionValue: 2,
  accumulated: 3,
  maximum: 4,
  maximum1T: 5,
  maximum2T: 6
}

export const METRIC_DETAIL_OMITTED_PROPERTIES = ['metricKey', 'refererId', 'unit', 'comparison']
